import React from 'react';
import { motion } from 'framer-motion';
import { MoveRight } from 'lucide-react';

const container = {
	initial: { opacity: 0, y: 20 },
	whileInView: { opacity: 1, y: 0 },
	transition: { duration: 0.6, ease: 'easeOut' }
};

const CareersIntro = () => {
	return (
		<section className="relative bg-white">
			{/* subtle top gradient to match the screenshot */}
			<div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-black/5 to-transparent pointer-events-none" />
			<div className="relative max-w-7xl mx-auto px-6 sm:px-8 md:px-12 py-10 sm:py-12">
				<div className="grid grid-cols-1 md:grid-cols-2 gap-10">
					<motion.p
						initial={container.initial}
						whileInView={container.whileInView}
						viewport={{ once: true, amount: 0.4 }}
						transition={{ ...container.transition, delay: 0.05 }}
						className="text-[13px] leading-6 text-[#2b2b2b] font-sans font-regular"
					>
						At Analytical Prism, we are more than just a workplace; we are a community of researchers, innovators,
						and problem-solvers dedicated to unlocking human potential through science. We believe that with the
						right people, equipped with the right tools and insights, transformative change can be achieved in education,
						workforce development, and personal growth.
					</motion.p>
					<div>
						<motion.p
							initial={container.initial}
							whileInView={container.whileInView}
							viewport={{ once: true, amount: 0.4 }}
							transition={{ ...container.transition, delay: 0.1 }}
							className="text-[13px] leading-6 text-[#2b2b2b] font-sans font-regular"
						>
							Whether you are an experienced professional, an aspiring researcher, or a student seeking meaningful
							opportunities, Analytical Prism offers a platform for you to develop your skills, challenge
							conventional thinking, and make a significant impact.
						</motion.p>
						<motion.div
							initial={{ opacity: 0, y: 8 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true, amount: 0.5 }}
							transition={{ duration: 0.4, delay: 0.2 }}
							className="mt-4"
						>
							<a
								href="/contact"
								className="inline-flex items-center font-sans font-regular gap-2 bg-lime-500 hover:bg-lime-600 text-[#2b2b2b] text-sm font-semibold px-4 py-2 rounded-full shadow-sm transition-colors"
							>
								<span>Join Us</span>
								<MoveRight className="w-8 h-8 text-black group-hover:translate-x-1 transition-transform duration-200 font-source font-regular" />
							</a>
						</motion.div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default CareersIntro;


